import { IAdvertiserCategory, IAdvertiserPayload, IAdvertiserResponseItem } from '@/Interfaces/Advertiser.interface';
import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { MAX_BEESWAX_V2_PAGE_SIZE } from '@/constants/beeswax/v2';
import { ADVERTISERS_ENDPOINT, ADVERTISER_CATEGORIES_ENDPOINT } from '@/constants/endpoints';
import { SearchAdvertisersPayload } from '@/types/advertisers.types';
import axios from 'axios';

export const fetchAdvertisers = async (
  params: SearchAdvertisersPayload,
): Promise<IPaginatedApiResponse<IAdvertiserResponseItem[]>> => {
  const res = await axios.get(ADVERTISERS_ENDPOINT, { params });
  return res.data;
};

export const fetchAdvertiserCategories = async (): Promise<{ results: IAdvertiserCategory[] }> => {
  const resp = await axios.get(ADVERTISER_CATEGORIES_ENDPOINT, { params: { page_size: MAX_BEESWAX_V2_PAGE_SIZE } });
  return resp.data;
};

export const createAdvertiser = async (payload: IAdvertiserPayload): Promise<IAdvertiserResponseItem> => {
  const resp = await axios.post(ADVERTISERS_ENDPOINT, payload);
  return resp.data;
};

export const updateAdvertiser = async (id: number, payload: IAdvertiserPayload): Promise<IAdvertiserResponseItem> => {
  const resp = await axios.put(`${ADVERTISERS_ENDPOINT}/${id}`, payload);
  return resp.data;
};

export const archiveAdvertiserEntity = async (id: number, isArchived: boolean): Promise<IAdvertiserResponseItem> => {
  const resp = await axios.post(`${ADVERTISERS_ENDPOINT}/${id}/archive`, { isArchived });
  return resp.data;
};
